/**
 * news-ticker.js — băng "Breaking news" chạy liên tục ở utility topbar.
 *
 * Markup đầu vào chỉ cần track + các bài:
 *   [data-news-ticker] > .news-ticker__viewport > ul[data-news-ticker-track] > li > a
 * nên template WordPress chỉ việc lặp qua 10 bài mới nhất, không phải in gì thêm.
 *
 * Script làm 3 việc:
 *   1. Nhân đôi danh sách (bản sao aria-hidden, không cho tab vào) rồi gắn .is-ready.
 *      Keyframes chạy tới translateX(-50%) là vừa hết phần gốc nên vòng nối liền mạch.
 *   2. Tính --news-ticker-duration theo chiều rộng thật: 5 bài hay 20 bài thì chữ vẫn
 *      trôi qua mắt cùng một tốc độ. Đo lại sau khi web font nạp xong vì chữ dự phòng
 *      rộng khác, đo sớm quá thì tốc độ lệch.
 *   3. Chèn nút tạm dừng — nội dung tự chạy quá 5 giây bắt buộc phải dừng được (WCAG 2.2.2).
 *      Rê chuột và tab vào băng thì CSS tự dừng, không cần JS.
 *
 * Không chạy (JS lỗi, màn hình hẹp, prefers-reduced-motion, hoặc ít bài đủ nằm gọn một dòng):
 * băng đứng yên và cuộn ngang vẫn đọc được hết.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var SPEED = 55; // px mỗi giây

    var root = document.querySelector('[data-news-ticker]');
    if (!root) return;

    var track = root.querySelector('[data-news-ticker-track]');
    if (!track || track.children.length < 2) return;

    var viewport = track.parentNode;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return;

    // Chiều rộng phần gốc: phải đo TRƯỚC khi nhân đôi và giữ lại,
    // vì sau đó scrollWidth là của cả hai nửa.
    var width = 0;
    var ready = false;

    function setDuration() {
        if (!width) return;
        track.style.setProperty('--news-ticker-duration', Math.round(width / SPEED) + 's');
    }

    function setup() {
        // display:none dưới md -> scrollWidth = 0; đủ chỗ xếp hết bài thì cũng khỏi chạy
        if (ready || track.scrollWidth === 0 || track.scrollWidth <= viewport.clientWidth) return;

        width = track.scrollWidth;

        var originals = Array.prototype.slice.call(track.children);
        for (var i = 0; i < originals.length; i++) {
            var clone = originals[i].cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');

            // Bản sao chỉ để nhìn: trình đọc màn hình và phím Tab bỏ qua
            var link = clone.querySelector('a');
            if (link) link.setAttribute('tabindex', '-1');

            track.appendChild(clone);
        }

        setDuration();
        ready = true;
        root.classList.add('is-ready');
        root.appendChild(pause);
        renderPause();
    }

    // ----- Nút tạm dừng -----
    var pause = document.createElement('button');
    pause.className = 'news-ticker__pause';
    pause.type = 'button';

    function renderPause() {
        var paused = root.classList.contains('is-paused');
        pause.setAttribute('aria-label', paused ? 'Resume news ticker' : 'Pause news ticker');
        pause.innerHTML = '<i class="ph ' + (paused ? 'ph-play' : 'ph-pause') + '" aria-hidden="true"></i>';
    }

    pause.addEventListener('click', function () {
        root.classList.toggle('is-paused');
        renderPause();
    });

    // Tab tới link đang khuất: trình duyệt cuộn lén viewport để lộ nó ra (dù overflow:hidden),
    // làm băng lệch khỏi vị trí animation. Focus rời khỏi băng thì kéo về chỗ cũ.
    root.addEventListener('focusout', function (event) {
        if (!root.contains(event.relatedTarget)) viewport.scrollLeft = 0;
    });

    // Đo lại khi web font đã nạp — chỉ đổi tốc độ, không đụng tới mối nối
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
            if (ready) {
                width = track.scrollWidth / 2;
                setDuration();
            } else {
                setup();
            }
        });
    }

    // Từ mobile xoay/kéo rộng sang desktop thì băng mới có chỗ để chạy
    var resizeTimer;
    window.addEventListener('resize', function () {
        if (ready) return;
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(setup, 200);
    });

    setup();
})();
